import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.outstanding_view.repayMoreTitle',
        defaultMessage: 'Repay early for free'
    },
    description: {
        id: '_.outstanding_view.repayMoreInfo',
        defaultMessage:
            'Repay more than your usual monthly amount if you like – there’s no fee for that'
    },
    ctaText: {
        id: '_.outstanding_view.repayMoreCTA',
        defaultMessage: 'Repay early for free'
    }
});
